"use client";

import { Button } from "@/app/components/ui/button";
import { UserPlus } from "lucide-react";
import { generateVCard, VCARD_MIME_TYPE, type ContactData } from "./vcard";

// Windows-Geräte bekommen die Outlook-Classic-kompatible vCard 2.1
// (Windows-1252-Quoted-Printable), alle anderen die Standard-vCard 3.0
// in UTF-8. Eine einzige Datei kann beide Welten nicht zuverlässig bedienen.
const isWindowsDevice = () => navigator.userAgent.includes("Windows");

const GERMAN_TRANSLITERATIONS: Record<string, string> = {
  ä: "ae",
  ö: "oe",
  ü: "ue",
  Ä: "Ae",
  Ö: "Oe",
  Ü: "Ue",
  ß: "ss",
};

const toAsciiFileName = (name: string) =>
  name
    .replaceAll(/[äöüÄÖÜß]/g, (character) => GERMAN_TRANSLITERATIONS[character])
    .normalize("NFKD")
    .replaceAll(/[\u0300-\u036f]/g, "")
    .replaceAll(/[^\x20-\x7E]/g, "")
    .replaceAll(/[\\/:*?"<>|]/g, "-")
    .trim();

export default function DownloadContactButton({
  contactData,
}: {
  contactData: ContactData;
}) {
  const downloadVCard = () => {
    const variant = isWindowsDevice() ? "windows" : "standard";
    const vCardData = generateVCard(contactData, variant);
    const blob = new Blob([vCardData], { type: VCARD_MIME_TYPE });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${toAsciiFileName(contactData?.name || "") || "kontakt"}.vcf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <Button className="py-2" onClick={downloadVCard}>
      <UserPlus className="mr-2 h-4 w-4" />
      Zu Kontakten
    </Button>
  );
}
